<div class="login-wrapper">
  <mat-card class="login-card">
    <mat-card-title>Anmeldung</mat-card-title>
    <mat-card-content class="login-card-content">
      <form (keyup.enter)="loginUser()" (ngSubmit)="loginUser()" tabindex="0" [formGroup]="loginForm" class="login-card-form">
        @if (loginInvalid) {
          <mat-error style="margin-bottom: 4px">
            E-Mail oder Passwort inkorrekt. Bitte versuchen Sie es erneut!
          </mat-error>
        }
        <mat-form-field appearance="outline">
          <mat-label>E-Mail</mat-label>
          <input email="true"
            formControlName="username"
            matInput
            placeholder=""
            required
            type="email"
            autocomplete="username">
            @if (loginForm.controls.username.hasError('email') && !loginForm.controls.username.hasError('required')) {
              <mat-error
                class="warning"
                >Eingabe ist keine gültige E-Mail Adresse
              </mat-error>
            }
            @if (loginForm.controls.username.hasError('required')) {
              <mat-error
                class="warning"
                >E-Mail Adresse ist verpflichtend
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Passwort</mat-label>
            <input [type]="hide ? 'password' : 'text'" formControlName="password" matInput placeholder="Password"
              required autocomplete="current-password">
              <mat-icon (click)="hide = !hide" matSuffix>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              @if (loginForm.controls.password.hasError('required')) {
                <mat-error
                  >Passwort ist verpflichtend
                </mat-error>
              }
              @if (loginForm.controls.password.hasError('minlength') && !loginForm.controls.password.hasError('required')) {
                <mat-error
                  >Passwort muss mindestens 8 Zeichen lang sein
                </mat-error>
              }
            </mat-form-field>
          </form>
          <div id="login-button-wrapper">
            <button (click)="openResetPasswordDialog()" mat-raised-button>Passwort vergessen</button>
            <button (click)="loginUser()" color="primary" mat-raised-button>Anmelden</button>
          </div>
        </mat-card-content>
      </mat-card>
      <button id="register-button" (click)="openRegistrationDialog()" color="accent" mat-raised-button>Neues Konto anlegen</button>
    </div>
